import { render, staticRenderFns } from "./DesctivateContactPersonTasksDialog.vue?vue&type=template&id=ad122d56"
import script from "./DesctivateContactPersonTasksDialog.vue?vue&type=script&lang=ts"
export * from "./DesctivateContactPersonTasksDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports